<div *ngIf="loading.value" class="d-flex justify-content-center py-4">
    <mat-spinner></mat-spinner>
</div>
<div class="search-bar" *ngIf="!loading.value && users.length">
    <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search User</mat-label>
        <input type="text" matInput placeholder="Search by name or email..." [(ngModel)]="searchText">
        <button *ngIf="searchText" matSuffix mat-icon-button aria-label="Clear" (click)="searchText = ''">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
</div>
<div class="assignment-boxes" *ngIf="!loading.value && filteredUsers.length">
    <fieldset class="assignment-box" *ngFor="let user of filteredUsers; trackBy: trackByUserId">
        <legend class="assignment-legend">
            <span class="assignment-name">
                {{ user.name }}
                <span class="assignment-subtext">{{ user.email }}</span>
            </span>
            <mat-checkbox
                class="select-all-checkbox"
                [checked]="isAllSelected(user)"
                [indeterminate]="isIndeterminate(user)"
                (change)="onToggleSelectAll(user)">
                Select All
            </mat-checkbox>
        </legend>
        <div class="role-list">
            <mat-checkbox
                *ngFor="let role of roles"
                class="role-checkbox"
                [checked]="isChecked(user, role.id)"
                [disabled]="isFromDepartment(user, role.id)"
                [title]="isFromDepartment(user, role.id) ? 'Inherited from ' + user.departmentName + ' department' : ''"
                (change)="onToggle(user, role.id)">
                {{ role.name }}
            </mat-checkbox>
        </div>
    </fieldset>
</div>
<div class="empty-state" *ngIf="!loading.value && !users.length">
    No users found.
</div>
<div class="empty-state" *ngIf="!loading.value && users.length && !filteredUsers.length">
    No users match "{{ searchText }}".
</div>
